export default class CountriesAndCities {
  constructor(data = []) {
    this.data = data
    this.countries = this.getCountries()
    this.cities = this.getCities()
  }

  static empty() {
    return new CountriesAndCities([])
  }

  getCities() {
    const res = []

    this.data.forEach(({ cities, name: countryName }) => {
      if (cities && Array.isArray(cities)) {
        cities.forEach(city => res.push({
          code: city.code,
          name: `${city.name}, ${countryName}`,
          type: 'city'
        }))
      }
    })

    return res
  }

  getCountries() {
    return [...this.data].map(({ code, name }) => ({ code, name, type: 'country' }))
  }
}
